export default __webpack_public_path__ + "static/media/vlands_logo.af97d58eacdd2fc6e990f769a794cddc.svg";